import { render, staticRenderFns } from "./portfoliofiltercontrol.vue?vue&type=template&id=64d952ca&scoped=true&"
import script from "./portfoliofiltercontrol.vue?vue&type=script&lang=js&"
export * from "./portfoliofiltercontrol.vue?vue&type=script&lang=js&"
import style0 from "./portfoliofiltercontrol.vue?vue&type=style&index=0&id=64d952ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d952ca",
  null
  
)

export default component.exports